export class MnUsuariosRequest {
    idenT_USUARIO: number | null = null;
    username: string | null = null;
    emaiL_INTERNO: string | null = null;
    iD_TIPO_DOCUMENTO: number | null = null;
    nrO_DOCUMENTO: string | null = null;
    nombrE_COMPLETO: string | null = null;
    inD_ESTADO: boolean | null = null;
}